import { observable } from "mobx";

import { CustomIntegrationXeroStore } from "@stores/custom-integration/CustomIntegrationXeroStore.ts";

export class CustomIntegrationXeroUi {
  constructor(private store: CustomIntegrationXeroStore) {}

  @observable
  recentlyUpdatedXeroTenant?: string;

  @observable
  recentlySyncedGetKey?: string;
}
